module.exports = __webpack_public_path__ + "fonts/light.8e076f00.ttf";